// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Cameras Page - Estilo consistente con SitesPage */
.cameras-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #0a0a0a;
  color: #ffffff;
  overflow: hidden;
}

/* Header */
.cameras-page-header {
  background: #1a1a1a;
  border-bottom: 1px solid #374151;
  padding: 24px;
}

.cameras-page-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.cameras-page-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
}

.cameras-page-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #9ca3af;
}

/* Search and Filters */
.cameras-search-and-filters {
  display: flex;
  gap: 12px;
  align-items: center;
}

.cameras-search-container {
  position: relative;
  flex: 1 1;
}

.cameras-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}

.cameras-search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.cameras-search-input:focus {
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.cameras-search-input::placeholder {
  color: #6b7280;
}

.cameras-filter-select {
  min-width: 160px;
  padding: 10px 12px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
}

.cameras-filter-select:focus {
  border-color: #A61B34;
}

/* Buttons */
.cameras-btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #A61B34;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cameras-btn-primary:hover:not(:disabled) {
  background: #8B1528;
}

.cameras-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cameras-btn-secondary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #374151;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cameras-btn-secondary:hover:not(:disabled) {
  background: #4b5563;
}

.cameras-btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Dashboard Cards */
.cameras-dashboard {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin: 16px 0;
}

.cameras-stat-card {
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.cameras-stat-card:hover {
  border-color: #4b5563;
}

.cameras-stat-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cameras-stat-label {
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
}

.cameras-stat-number {
  font-size: 30px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.1;
}

.cameras-stat-green {
  color: #22c55e;
}

.cameras-stat-red {
  color: #ef4444;
}

.cameras-stat-blue {
  color: #60a5fa;
}

.cameras-stat-icon {
  color: #4b5563;
  flex-shrink: 0;
}

.cameras-stat-icon-red {
  color: #A61B34;
}

.cameras-stat-default-red {
  border-color: #A61B34;
}

.cameras-stat-default {
  border-color: #374151;
}

.cameras-stat-active-red {
  border-color: #A61B34;
  box-shadow: 0 4px 14px rgba(166, 27, 52, 0.25);
}

.cameras-stat-active-green {
  border-color: #22c55e;
  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.25);
}

.cameras-stat-active-green .cameras-stat-icon {
  color: #22c55e;
}

.cameras-stat-active-blue {
  border-color: #60a5fa;
  box-shadow: 0 4px 14px rgba(96, 165, 250, 0.25);
}

.cameras-stat-active-blue .cameras-stat-icon {
  color: #60a5fa;
}

/* Mismo semáforo visual que Sitios (sites-state-sema) */
.cameras-op-sema {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  line-height: 1.2;
}

.cameras-op-sema__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.12);
}

.cameras-op-sema--on {
  color: #bbf7d0;
  background: rgba(34, 197, 94, 0.14);
  border-color: rgba(34, 197, 94, 0.35);
}
.cameras-op-sema--on .cameras-op-sema__dot {
  background: #22c55e;
}

.cameras-op-sema--issue {
  color: #ffedd5;
  background: rgba(249, 115, 22, 0.16);
  border-color: rgba(249, 115, 22, 0.4);
}
.cameras-op-sema--issue .cameras-op-sema__dot {
  background: #f97316;
}

.cameras-op-sema--off {
  color: #fecaca;
  background: rgba(220, 38, 38, 0.14);
  border-color: rgba(220, 38, 38, 0.38);
}
.cameras-op-sema--off .cameras-op-sema__dot {
  background: #dc2626;
}

.cameras-op-sema--unknown {
  color: #d1d5db;
  background: rgba(107, 114, 128, 0.18);
  border-color: rgba(107, 114, 128, 0.35);
}
.cameras-op-sema--unknown .cameras-op-sema__dot {
  background: #6b7280;
}

/* Content Area */
.cameras-content {
  flex: 1 1;
  overflow: auto;
  padding: 24px;
}

/* Error */
.cameras-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 0 24px 16px 24px;
  font-size: 14px;
}

/* Table Container */
.cameras-table-container {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.cameras-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #0a0a0a;
  border-bottom: 1px solid #374151;
}

.cameras-table-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

/* Table */
.cameras-table {
  width: 100%;
  border-collapse: collapse;
}

.cameras-table thead {
  background: #0a0a0a;
}

.cameras-table th {
  padding: 16px 24px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #374151;
}

.cameras-table tbody {
  background: #1a1a1a;
}

.cameras-table tbody tr {
  border-bottom: 1px solid #374151;
  transition: background-color 0.2s;
}

.cameras-table tbody tr:hover {
  background: #252525;
}

.cameras-table td {
  padding: 16px 24px;
  font-size: 14px;
  color: #ffffff;
}

/* Empty State */
.cameras-empty {
  text-align: center;
  padding: 48px 24px !important;
}

.cameras-empty-icon {
  color: #6b7280;
  margin: 0 auto 16px auto;
}

.cameras-empty p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

/* Table Cells */
.cameras-cell-with-icon {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cameras-icon-badge {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(166, 27, 52, 0.2);
  border: 1px solid rgba(166, 27, 52, 0.3);
  border-radius: 8px;
  color: #A61B34;
}

.cameras-cell-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.cameras-cell-subtitle {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}

.cameras-cell-text {
  font-size: 14px;
  color: #e5e7eb;
}

.cameras-cell-mono {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #e5e7eb;
}

/* Badges */
.cameras-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.cameras-badge-success {
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.cameras-badge-inactive {
  background: rgba(107, 114, 128, 0.15);
  color: #9ca3af;
  border: 1px solid rgba(107, 114, 128, 0.3);
}

.cameras-badge-info {
  background: rgba(59, 130, 246, 0.15);
  color: #93c5fd;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

/* Action Buttons */
.cameras-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.cameras-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #374151;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.cameras-action-btn:hover:not(:disabled) {
  transform: scale(1.05);
}

.cameras-action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.cameras-action-btn-stream:hover:not(:disabled) {
  background: #4B5563;
  color: #f87171;
}

.cameras-action-btn-recordings:hover:not(:disabled) {
  background: #4B5563;
  color: #60A5FA;
}

.cameras-action-btn-edit:hover:not(:disabled) {
  background: #4B5563;
  color: #fbbf24;
}

/* Pagination */
.cameras-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #0a0a0a;
  border-top: 1px solid #374151;
}

.cameras-pagination-info {
  font-size: 13px;
  color: #9ca3af;
}

.cameras-pagination-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.cameras-pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #374151;
  border-radius: 6px;
  background: transparent;
  color: #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cameras-pagination-btn:hover:not(:disabled):not(.active) {
  background: #374151;
  border-color: #4b5563;
}

.cameras-pagination-btn.active {
  background: #A61B34;
  border-color: #A61B34;
  color: #ffffff;
  font-weight: 600;
}

.cameras-pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.cameras-pagination-dots {
  padding: 0 4px;
  color: #6b7280;
  font-size: 13px;
}

/* Responsive */
@media (max-width: 768px) {
  .cameras-page-header {
    padding: 16px;
  }

  .cameras-page-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .cameras-search-and-filters {
    flex-direction: column;
    width: 100%;
  }

  .cameras-search-container {
    width: 100%;
  }

  .cameras-filter-select {
    width: 100%;
  }

  .cameras-content {
    padding: 16px;
  }

  .cameras-table th,
  .cameras-table td {
    padding: 12px 16px;
  }

  .cameras-actions {
    flex-direction: column;
  }

  .cameras-dashboard {
    grid-template-columns: repeat(2, 1fr);
  }

  .cameras-pagination {
    flex-direction: column;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .cameras-dashboard {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CamerasPage.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Cameras Page - Estilo consistente con SitesPage */\n.cameras-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #0a0a0a;\n  color: #ffffff;\n  overflow: hidden;\n}\n\n/* Header */\n.cameras-page-header {\n  background: #1a1a1a;\n  border-bottom: 1px solid #374151;\n  padding: 24px;\n}\n\n.cameras-page-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.cameras-page-title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.cameras-page-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n/* Search and Filters */\n.cameras-search-and-filters {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.cameras-search-container {\n  position: relative;\n  flex: 1;\n}\n\n.cameras-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n.cameras-search-input {\n  width: 100%;\n  padding: 12px 12px 12px 44px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.cameras-search-input:focus {\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.cameras-search-input::placeholder {\n  color: #6b7280;\n}\n\n.cameras-filter-select {\n  min-width: 160px;\n  padding: 10px 12px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cameras-filter-select:focus {\n  border-color: #A61B34;\n}\n\n/* Buttons */\n.cameras-btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #A61B34;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cameras-btn-primary:hover:not(:disabled) {\n  background: #8B1528;\n}\n\n.cameras-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cameras-btn-secondary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #374151;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cameras-btn-secondary:hover:not(:disabled) {\n  background: #4b5563;\n}\n\n.cameras-btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Dashboard Cards */\n.cameras-dashboard {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin: 16px 0;\n}\n\n.cameras-stat-card {\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.cameras-stat-card:hover {\n  border-color: #4b5563;\n}\n\n.cameras-stat-left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cameras-stat-label {\n  font-size: 12px;\n  font-weight: 400;\n  color: #9ca3af;\n}\n\n.cameras-stat-number {\n  font-size: 30px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.1;\n}\n\n.cameras-stat-green {\n  color: #22c55e;\n}\n\n.cameras-stat-red {\n  color: #ef4444;\n}\n\n.cameras-stat-blue {\n  color: #60a5fa;\n}\n\n.cameras-stat-icon {\n  color: #4b5563;\n  flex-shrink: 0;\n}\n\n.cameras-stat-icon-red {\n  color: #A61B34;\n}\n\n.cameras-stat-default-red {\n  border-color: #A61B34;\n}\n\n.cameras-stat-default {\n  border-color: #374151;\n}\n\n.cameras-stat-active-red {\n  border-color: #A61B34;\n  box-shadow: 0 4px 14px rgba(166, 27, 52, 0.25);\n}\n\n.cameras-stat-active-green {\n  border-color: #22c55e;\n  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.25);\n}\n\n.cameras-stat-active-green .cameras-stat-icon {\n  color: #22c55e;\n}\n\n.cameras-stat-active-blue {\n  border-color: #60a5fa;\n  box-shadow: 0 4px 14px rgba(96, 165, 250, 0.25);\n}\n\n.cameras-stat-active-blue .cameras-stat-icon {\n  color: #60a5fa;\n}\n\n/* Mismo semáforo visual que Sitios (sites-state-sema) */\n.cameras-op-sema {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 12px 5px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid transparent;\n  line-height: 1.2;\n}\n\n.cameras-op-sema__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.12);\n}\n\n.cameras-op-sema--on {\n  color: #bbf7d0;\n  background: rgba(34, 197, 94, 0.14);\n  border-color: rgba(34, 197, 94, 0.35);\n}\n.cameras-op-sema--on .cameras-op-sema__dot {\n  background: #22c55e;\n}\n\n.cameras-op-sema--issue {\n  color: #ffedd5;\n  background: rgba(249, 115, 22, 0.16);\n  border-color: rgba(249, 115, 22, 0.4);\n}\n.cameras-op-sema--issue .cameras-op-sema__dot {\n  background: #f97316;\n}\n\n.cameras-op-sema--off {\n  color: #fecaca;\n  background: rgba(220, 38, 38, 0.14);\n  border-color: rgba(220, 38, 38, 0.38);\n}\n.cameras-op-sema--off .cameras-op-sema__dot {\n  background: #dc2626;\n}\n\n.cameras-op-sema--unknown {\n  color: #d1d5db;\n  background: rgba(107, 114, 128, 0.18);\n  border-color: rgba(107, 114, 128, 0.35);\n}\n.cameras-op-sema--unknown .cameras-op-sema__dot {\n  background: #6b7280;\n}\n\n/* Content Area */\n.cameras-content {\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n}\n\n/* Error */\n.cameras-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #f87171;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin: 0 24px 16px 24px;\n  font-size: 14px;\n}\n\n/* Table Container */\n.cameras-table-container {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.cameras-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #0a0a0a;\n  border-bottom: 1px solid #374151;\n}\n\n.cameras-table-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* Table */\n.cameras-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.cameras-table thead {\n  background: #0a0a0a;\n}\n\n.cameras-table th {\n  padding: 16px 24px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid #374151;\n}\n\n.cameras-table tbody {\n  background: #1a1a1a;\n}\n\n.cameras-table tbody tr {\n  border-bottom: 1px solid #374151;\n  transition: background-color 0.2s;\n}\n\n.cameras-table tbody tr:hover {\n  background: #252525;\n}\n\n.cameras-table td {\n  padding: 16px 24px;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n/* Empty State */\n.cameras-empty {\n  text-align: center;\n  padding: 48px 24px !important;\n}\n\n.cameras-empty-icon {\n  color: #6b7280;\n  margin: 0 auto 16px auto;\n}\n\n.cameras-empty p {\n  margin: 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Table Cells */\n.cameras-cell-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.cameras-icon-badge {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(166, 27, 52, 0.2);\n  border: 1px solid rgba(166, 27, 52, 0.3);\n  border-radius: 8px;\n  color: #A61B34;\n}\n\n.cameras-cell-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.cameras-cell-subtitle {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-top: 2px;\n}\n\n.cameras-cell-text {\n  font-size: 14px;\n  color: #e5e7eb;\n}\n\n.cameras-cell-mono {\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: #e5e7eb;\n}\n\n/* Badges */\n.cameras-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.cameras-badge-success {\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.cameras-badge-inactive {\n  background: rgba(107, 114, 128, 0.15);\n  color: #9ca3af;\n  border: 1px solid rgba(107, 114, 128, 0.3);\n}\n\n.cameras-badge-info {\n  background: rgba(59, 130, 246, 0.15);\n  color: #93c5fd;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n/* Action Buttons */\n.cameras-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.cameras-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: #374151;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cameras-action-btn:hover:not(:disabled) {\n  transform: scale(1.05);\n}\n\n.cameras-action-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.cameras-action-btn-stream:hover:not(:disabled) {\n  background: #4B5563;\n  color: #f87171;\n}\n\n.cameras-action-btn-recordings:hover:not(:disabled) {\n  background: #4B5563;\n  color: #60A5FA;\n}\n\n.cameras-action-btn-edit:hover:not(:disabled) {\n  background: #4B5563;\n  color: #fbbf24;\n}\n\n/* Pagination */\n.cameras-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: #0a0a0a;\n  border-top: 1px solid #374151;\n}\n\n.cameras-pagination-info {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.cameras-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.cameras-pagination-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  background: transparent;\n  color: #e5e7eb;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cameras-pagination-btn:hover:not(:disabled):not(.active) {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.cameras-pagination-btn.active {\n  background: #A61B34;\n  border-color: #A61B34;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.cameras-pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.cameras-pagination-dots {\n  padding: 0 4px;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .cameras-page-header {\n    padding: 16px;\n  }\n\n  .cameras-page-header-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .cameras-search-and-filters {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .cameras-search-container {\n    width: 100%;\n  }\n\n  .cameras-filter-select {\n    width: 100%;\n  }\n\n  .cameras-content {\n    padding: 16px;\n  }\n\n  .cameras-table th,\n  .cameras-table td {\n    padding: 12px 16px;\n  }\n\n  .cameras-actions {\n    flex-direction: column;\n  }\n\n  .cameras-dashboard {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .cameras-pagination {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .cameras-dashboard {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
